import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import api, { clearToken } from '../services/api';

interface SidebarProps {
  onLogout?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onLogout }) => {
  const [pendingCount, setPendingCount] = useState(0);
  const [emergencyCount, setEmergencyCount] = useState(0);

  useEffect(() => {
    api.loc.getAll()
      .then(res => {
        const data = res.data || res;
        if (Array.isArray(data)) {
          setPendingCount(data.filter((l: any) => l.status === 'submitted' || l.status === 'under_review').length);
          setEmergencyCount(data.filter((l: any) => l.isEmergency && l.status !== 'completed' && l.status !== 'rejected').length);
        }
      })
      .catch(() => {});
  }, []);

  const navItems = [
    { section: 'OVERVIEW' },
    { to: '/', icon: '\u229E', label: 'Dashboard' },
    { section: 'LOC MANAGEMENT' },
    { to: '/applications', icon: '\uD83D\uDCCB', label: 'Applications', badge: pendingCount, badgeType: 'red' as const },
    { to: '/approvals', icon: '\u2713', label: 'Pending Approvals', badge: pendingCount },
    { to: '/emergency', icon: '\uD83D\uDEA8', label: 'Emergency LOCs', badge: emergencyCount, badgeType: emergencyCount > 0 ? 'red' as const : undefined },
    { section: 'ENTITIES' },
    { to: '/officers', icon: '\uD83D\uDC64', label: 'Officers' },
    { to: '/hospitals', icon: '\uD83C\uDFE5', label: 'Hospitals' },
    { section: 'REPORTS' },
    { to: '/reports/reconciliation', icon: '\u20B9', label: 'Reconciliation' },
    { to: '/reports/disbursement', icon: '\uD83D\uDCCA', label: 'Disbursement' },
    { to: '/reports/category', icon: '\uD83D\uDC65', label: 'Category-wise' },
    { to: '/reports/hospital', icon: '\uD83C\uDFE5', label: 'Hospital-wise' },
    { to: '/reports/sla', icon: '\u23F1', label: 'SLA Performance' },
    { section: 'SYSTEM' },
    { to: '/audit', icon: '\uD83D\uDCDD', label: 'Audit Logs' },
    { to: '/settings', icon: '\u2699', label: 'Settings' },
  ];

  const handleLogout = () => {
    clearToken();
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-brand-icon">+</div>
        <h1>AIS Officers Healthcare</h1>
        <p>Admin Panel — APCFSS</p>
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item, i) =>
          'section' in item && item.section ? (
            <div key={i} className="nav-section">{item.section}</div>
          ) : 'to' in item ? (
            <NavLink
              key={i}
              to={item.to!}
              end={item.to === '/'}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
              {item.badge ? (
                <span className={`nav-badge${item.badgeType === 'red' ? '' : ' gold'}`}>
                  {item.badge}
                </span>
              ) : null}
            </NavLink>
          ) : null
        )}
      </nav>
      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">AD</div>
          <div>
            <div className="sidebar-user-name">Admin User</div>
            <div className="sidebar-user-role">CEO, Dr. NTR Vaidya Seva Trust</div>
          </div>
        </div>
        {onLogout && (
          <button
            onClick={handleLogout}
            className="header-btn secondary"
            style={{
              width: '100%',
              justifyContent: 'center',
              marginTop: '12px',
              fontSize: '12px',
              color: 'rgba(255,255,255,0.5)',
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.08)',
            }}
          >
            Sign Out
          </button>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
